package com.xtream.ui.tv.presentation.series

import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.paging.compose.collectAsLazyPagingItems
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.tv_shows
import com.xtream.composeapp.viewmodel.SeriesViewModel
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.ui.platform.adaptiveValue
import com.xtream.ui.tv.presentation.common.ContentGridTvScreen
import com.xtream.ui.ui.widget.NetworkImageCard
import com.xtream.ui.ui.widget.Visibility
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalStdlibApi::class)
@Composable
fun TvShowGridTvScreen(
    modifier: Modifier=  Modifier,
    id: Int? = null,
    query: String? = null,
    title: String? = null,
    navKey: Screen.SeriesGrid,
){
   val seriesViewModel: SeriesViewModel = koinViewModel( key="seriesStream_${navKey::class.simpleName}${navKey.hashCode()}")/*hiltViewModel<SeriesViewModel, SeriesViewModel.Factory>(
       creationCallback = { factory ->
           factory.create(navKey)
       }
   )*/
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )
    val scrollState = rememberLazyGridState()

    LaunchedEffect( query) {
        seriesViewModel.searchByCategoryFlow.value = id
        seriesViewModel.search( query)

        scrollState.scrollToItem(0)
    }

    val homeScreenPagedItems
            = seriesViewModel.seriesStreamsFilteredPagingFlow.collectAsLazyPagingItems()


    val columnsNum= adaptiveValue(expandedValue = 7, compactValue = 3, default = 3)
    ContentGridTvScreen(
        modifier = modifier,
        numColumns = columnsNum,
        title  = {
            Text(
                stringResource(Res.string.tv_shows),
                style = MaterialTheme.typography.headlineMedium
            )
        },
        subtitle  = title?.takeIf { it.isNotEmpty() }?.let { {
            Text(title, style = MaterialTheme.typography.titleMedium)}},


        carousel = {

        },
        lazyPagingItems = homeScreenPagedItems,

        ){

        (it as? SeriesStream?)?.let { stream->
            NetworkImageCard(
                src=stream.streamIcon,
                useAutoAlpha = true,
                 title = stream.name?:"",
                /* description = stream.formattedRating()?:"",*/
                //dependOnWidth = false,

                infoSectionVisibility= Visibility.VISIBLE_ALWAYS,
               width = (-1).dp,
                // to fill width
                onClick = {
                    rootNavViewModel.navigate(Screen.TvShowDetail(stream.streamId))
                }
            )
        }

    }


}




